import moment from 'moment';
import { subscriptionActions, dateFormats, familyName, errorMessages } from '../../constants';
import getDynamicString from './getDynamicString';
import { normalizeProductFamily } from '../../constants/products';
import { isAnnualBillingFrequency } from './flexBillingFrequency';

export type DefermentInfo = {
  defermentDt: string;
  type: string;
  defermentPlanCode?: string | null;
  termFrequency?: string | null;
};

const getDefermentInfo = (defermentInfo?: DefermentInfo): string | undefined => {
  let defermentMessage: string | undefined;
  if (defermentInfo) {
    const { defermentDt, type, defermentPlanCode, termFrequency } = defermentInfo;
    const defermentDate = moment(defermentDt).isValid()
      ? moment(defermentDt).format(dateFormats.long)
      : 'your next billing date';
    switch (type) {
      case subscriptionActions.activation: {
        const family = defermentPlanCode
          ? familyName[normalizeProductFamily(defermentPlanCode) as keyof typeof familyName]
          : undefined;
        const familyLabel = family && isAnnualBillingFrequency(termFrequency) ? `${family} - Annual` : family;
        defermentMessage = familyLabel
          ? getDynamicString('subscriptions.pendingChange', [familyLabel, defermentDate])
          : errorMessages.default;
        break;
      }
      case subscriptionActions.cancellation:
        defermentMessage = getDynamicString('subscriptions.pendingCancellation', [defermentDate]);
        break;
      default:
        defermentMessage = errorMessages.default;
        break;
    }
  }
  return defermentMessage;
};

export default getDefermentInfo;
